"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrientationOpportunityRequestStatus = void 0;
exports.instanceOfOrientationOpportunityRequestStatus = instanceOfOrientationOpportunityRequestStatus;
exports.OrientationOpportunityRequestStatusFromJSON = OrientationOpportunityRequestStatusFromJSON;
exports.OrientationOpportunityRequestStatusFromJSONTyped = OrientationOpportunityRequestStatusFromJSONTyped;
exports.OrientationOpportunityRequestStatusToJSON = OrientationOpportunityRequestStatusToJSON;
exports.OrientationOpportunityRequestStatusToJSONTyped = OrientationOpportunityRequestStatusToJSONTyped;
/**
 *
 * @export
 */
exports.OrientationOpportunityRequestStatus = {
    Requested: 'REQUESTED',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    Withdrawn: 'WITHDRAWN'
};
function instanceOfOrientationOpportunityRequestStatus(value) {
    for (const key in exports.OrientationOpportunityRequestStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.OrientationOpportunityRequestStatus, key)) {
            if (exports.OrientationOpportunityRequestStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function OrientationOpportunityRequestStatusFromJSON(json) {
    return OrientationOpportunityRequestStatusFromJSONTyped(json, false);
}
function OrientationOpportunityRequestStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function OrientationOpportunityRequestStatusToJSON(value) {
    return value;
}
function OrientationOpportunityRequestStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=OrientationOpportunityRequestStatus.js.map